/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment, useEffect, useState } from 'react'
import useRootStore from '@store/useRootStore'
import BottomLoading from '@components/BottomLoading'
import * as Utils from '@utils/utils'
import {
  formatNumber,
  formatNumberTicketCount,
  getRatioTicketMoney,
  getTicketCountFromTicket,
  getTicketFromTicketCount,
  isExtraOddsItemSupportBetMoneyType,
  isShowDiaAdvertisementImage,
  makeLimitBettingRateText,
  makeMaxBetAlertText,
  maxTicketBetMoney,
  showCasinoAdvertisementPopup,
  showToast,
  TOAST_TYPE,
  updateDiaAdvertisementImageLastShowedAt,
} from '@utils/utils'
import { observer } from 'mobx-react'
import { Popover } from 'antd'
import { Badge, Tabs } from 'antd-mobile'
import { filter, find, isEmpty, size } from 'lodash'
import NumberFormat, { NumberFormatValues } from 'react-number-format'
// icon
import { DiaIco, GmoneyIco } from '@shared/Icon/MoneyIcon'
import { DiaTxtIco, PopoverIco } from '@shared/Icon/EtcIcon'
import { PROPERTY_ID } from 'adv-protocol/src/GameCommon'
// image
import BetCouponImg from '@assets/images/icon/matchup_icon/betting-coupon-10000.png'
import BetslipDiaGuideImg from '@assets/images/text/betslip-dia-guide-txt.png'
import BetslipSlipGuideImg from '@assets/images/text/betslip-slip-guide-txt.png'
import UserPickBannerImg from '@assets/images/banner/user-pick-product/user-pick-propmotion-banner-betting-slip.png'
// css
import { BadgeStyle, ModalBg, TabTxt, WhiteChildTabWrap } from '@styles/base.style'
import { Button, SwitchBtn } from '@styles/button.style'
import {
  BET_SLIP_BTN_TYPE,
  BET_SLIP_TAB_INDEX_KEY,
  BET_TICKET_TYPE,
  DIA_ADVERTISEMENT_IMAGE_DISPLAYABLE_VIEW_TYPE,
} from '@constants/index'
import { isAndroid, isIOS, isMobile } from 'react-device-detect'
import { GAME_TYPE } from '@game-type/game-market-types'
import BettingHistory from '@views/BettingHistory'
import { Models } from 'rmc-tabs/lib/Models'
import BubblePopup from '@views/Matchup/BetSlip/Bubble/index'
import { BubbleTextType, BubbleType } from '@store/globalStore'
import {
  BetSlipBottomModal,
  BetSlipBottomWrapper,
  BetSlipGuideTxtWrap,
  BetSlipListWrap,
  BetSlipPenaltyWrap,
} from './index.style'
import {
  doBet,
  exchangeMoneyByBetMoneyType,
  getBetMoneyTypeFromSelectedBetSlipTab,
  getHitMoney,
  getPenaltyAppliedRate,
  getRate,
  isExceedMaxBetMoney,
  isInputNotAvailable,
  makeFoldItems,
  maxBetMoneyByBetMoneyType,
  onClickCouponAllin,
  onClickMoneyAllin,
  onClickMoneyButton,
  onClickMoneyReset,
  setUserInputBetMoney,
} from './BetSlipHelper'
import AdditionalDividendCard from './AdditionalDividendCard'
import StorageUtils from '@utils/storage-utils'
import { AdvButton } from '@components/Button'
import PopupUtils from '@utils/popup-utils'
import { UserPickBannerStyle } from '@views/BettingHistory/BettingHistoryListItem/index.style'
import classNames from 'classnames'
import Login from '@views/Login'
import { FROM_VIEW_TYPE } from '@v2/constants/common'

// 배당 페널티 툴팁
export const betSlipPenaltyTxt = (
  <BetSlipPenaltyWrap>
    <span className="penalty-info">1 폴드 베팅 시 배당이 감소됩니다.</span>
    <span className="penalty-sub-info">(2 폴드 이상은 감소되지 않습니다.)</span>
  </BetSlipPenaltyWrap>
)

let timer = null

const BetSlipBottom: React.FC = () => {
  const {
    matchupStore,
    authStore,
    globalStore,
    bettingHistoryStore,
    routerStore,
    componentStore,
    logStore,
  } = useRootStore()
  const { visibleBetCompleteAni } = globalStore
  const godBlessItemEnabled = globalStore.getGodBlessItemEnabled()

  const {
    cart = [],
    betMoney = 0,
    minimizeBetSlip,
    categoryTab,
    sportTab,
    isKeepCart,
    isBetting,
    clubOption,
    club,
    selectedBetSlipTabIndexKey,
    typeOn,
    useBetSlipRefreshButtonInsteadOfBettingButton,
  } = matchupStore

  const isSingleBetPenalty = cart.length === 1 && cart[0].gameKey !== GAME_TYPE.LIVE
  const betInputClassName = 'bet-input-aaaaa'

  const betMoneyType = getBetMoneyTypeFromSelectedBetSlipTab()

  const limitBettingRateText = makeLimitBettingRateText(clubOption?.limit_betting_rate ?? club?.limit_betting_rate)
  const { userInfo } = authStore
  const { onGoingBetCount } = bettingHistoryStore
  const { money, dia, diaCasino, ticket } = userInfo
  const { selectedUserExtraOddsItem } = componentStore

  const diaMoney = Number(dia) - Number(diaCasino)
  const [updater, setUpdater] = useState(0)
  const [betSlipGuideClass, setBetSlipGuideClass] = useState('')

  const [beforeFoldCount, setBeforeFoldCount] = useState(cart.length)
  const [beforeRate, setBeforeRate] = useState(isSingleBetPenalty
    ? getPenaltyAppliedRate(cart, selectedUserExtraOddsItem?.rate)
    : getRate(cart, selectedUserExtraOddsItem?.rate))

  const [foldClass, setFoldClass] = useState('')
  const [rateClass, setRateClass] = useState('')

  const gMoneyButtonMobile = [
    BET_SLIP_BTN_TYPE.RESET,
    BET_SLIP_BTN_TYPE.MAX,
    BET_SLIP_BTN_TYPE.TEN_THOUSAND,
    BET_SLIP_BTN_TYPE.FIFTY_THOUSAND,
    BET_SLIP_BTN_TYPE.ONE_HUNDRED_THOUSAND,
    BET_SLIP_BTN_TYPE.FIVE_HUNDRED_THOUSAND]
  const gMoneyButtonPC = [
    BET_SLIP_BTN_TYPE.ONE_HUNDRED_THOUSAND,
    BET_SLIP_BTN_TYPE.FIVE_HUNDRED_THOUSAND,
    BET_SLIP_BTN_TYPE.RESET,
    BET_SLIP_BTN_TYPE.TEN_THOUSAND,
    BET_SLIP_BTN_TYPE.FIFTY_THOUSAND,
    BET_SLIP_BTN_TYPE.MAX]

  const diaButtonMobile = [
    BET_SLIP_BTN_TYPE.RESET,
    BET_SLIP_BTN_TYPE.MAX,
    BET_SLIP_BTN_TYPE.TEN_THOUSAND,
    BET_SLIP_BTN_TYPE.FIFTY_THOUSAND,
    BET_SLIP_BTN_TYPE.ONE_HUNDRED_THOUSAND,
    BET_SLIP_BTN_TYPE.ONE_MILLION]
  const diaButtonPC = [
    BET_SLIP_BTN_TYPE.ONE_HUNDRED_THOUSAND,
    BET_SLIP_BTN_TYPE.ONE_MILLION,
    BET_SLIP_BTN_TYPE.RESET,
    BET_SLIP_BTN_TYPE.TEN_THOUSAND,
    BET_SLIP_BTN_TYPE.FIFTY_THOUSAND,
    BET_SLIP_BTN_TYPE.MAX]

  const couponButtonMobile = [
    BET_SLIP_BTN_TYPE.RESET,
    BET_SLIP_BTN_TYPE.MAX,
    BET_SLIP_BTN_TYPE.ONE,
    BET_SLIP_BTN_TYPE.FIVE,
    BET_SLIP_BTN_TYPE.TEN,
    BET_SLIP_BTN_TYPE.FIFTY]
  const couponButtonPC = [
    BET_SLIP_BTN_TYPE.ONE,
    BET_SLIP_BTN_TYPE.FIVE,
    BET_SLIP_BTN_TYPE.RESET,
    BET_SLIP_BTN_TYPE.TEN,
    BET_SLIP_BTN_TYPE.FIFTY,
    BET_SLIP_BTN_TYPE.MAX]

  const targetCart = cart
  const targetBetMoney = betMoney
  const Wrapping = BetSlipBottomWrapper

  const initialBetMoney = targetBetMoney
  const uiInitialBetMoney = betMoneyType === PROPERTY_ID.NEW_BET_TICKET_G
    ? getRatioTicketMoney(initialBetMoney) : initialBetMoney

  const funcClearCart = matchupStore.clearCart

  const clearAllCart = () => {
    if (isMobile) {
      showCasinoAdvertisementPopup()
      matchupStore.resetPreMatchBetSuccessCountAfterBetSlipOpened()
      matchupStore.toggleMinimizeBetSlip(true)
    }
    funcClearCart()
  }

  // 로그인 되어있으면 진행중 카운트 가져오기
  useEffect(() => {
    if (authStore?.isSignedIn) {
      clearTimeout(timer)
      timer = setTimeout(async () => {
        await bettingHistoryStore.fetchBettingTotalCount(false, false)
      }, 500)
    }
  }, [authStore?.isSignedIn])

  useEffect(() => {
    if (selectedBetSlipTabIndexKey !== BET_SLIP_TAB_INDEX_KEY.MONEY &&
      authStore.userInfo.ticket < BET_TICKET_TYPE.BET_TICKET1) {
      matchupStore.setSelectedBetSlipTabIndexKey(BET_SLIP_TAB_INDEX_KEY.MONEY)
      onClickMoneyReset()
    }
  }, [authStore?.userInfo?.ticket])

  const simple = []
  if (minimizeBetSlip) {
    simple.push('simple-betslip-top')
    // simple.push('hide-simple')
    // 채팅 보이기
  } else {
    simple.push('hide-simple')
    // 채팅 가리기
    globalStore.setIgnoreVisibleChangeHandler(false)
  }
  const detail: string[] = []
  if (isMobile) {
    if (!minimizeBetSlip) {
      detail.push('betslip-detail test')
    } else {
      detail.push('hide-detail')
      // detail.push('betslip-detail')
    }
  } else {
    detail.push('betslip-detail')
  }

  let extraOddsRate: number
  if (isExtraOddsItemSupportBetMoneyType(betMoneyType)) {
    extraOddsRate = selectedUserExtraOddsItem?.rate
  }

  const rate = isSingleBetPenalty
    ? getPenaltyAppliedRate(targetCart, extraOddsRate)
    : getRate(targetCart, extraOddsRate)
  const hitMoney = getHitMoney(targetBetMoney, rate)
  const exchangedHitMoney = exchangeMoneyByBetMoneyType(hitMoney, betMoneyType)
  const foldCount = targetCart.length

  const updateFoldClass = () => {
    if (foldCount !== beforeFoldCount) {
      setBeforeFoldCount(foldCount)
      setFoldClass(makeChangeClass(foldCount))
    }
  }

  const updateRateClass = () => {
    if (beforeRate !== rate) {
      setBeforeRate(rate)
      setRateClass(makeChangeClass(rate))
    }
  }

  const makeChangeClass = (value) => {
    if (value % 2 === 1) {
      return 'change-odds'
    }
    return 'change-even'
  }

  updateFoldClass()
  updateRateClass()

  const betSlipAniSec = Number(0.6) // 단위: s
  setTimeout(() => {
    if (foldClass !== '') {
      setFoldClass('')
      setUpdater(updater + 1)
    }
    if (rateClass !== '') {
      setRateClass('')
      setUpdater(updater + 1)
    }
  }, (betSlipAniSec * 1000))

  // const bet_min_max = makeBetMoneyRangeText()

  let betButtonClassName = 'do-bet-btn'
  if (matchupStore.cart.length === 0) {
    matchupStore.toggleMinimizeBetSlip(true)
    betButtonClassName += ' disabled'
  }


  const onClickBetSlipExpandButton = () => {
    logStore.writeButtonLog({ pageId: 'b070', buttonId: '001' }).catch(console.error)
    if (matchupStore.cart.length > 0) {
      matchupStore.toggleMinimizeBetSlip(false)
    }
  }


  const onClickBetSlipCollapseButton = () => {
    if (isMobile) {
      showCasinoAdvertisementPopup()
      matchupStore.resetPreMatchBetSuccessCountAfterBetSlipOpened()
    }

    matchupStore.setUseBetSlipRefreshButtonInsteadOfBettingButton(false)
    matchupStore.toggleMinimizeBetSlip(true)
    if (isShowDiaAdvertisementImage(DIA_ADVERTISEMENT_IMAGE_DISPLAYABLE_VIEW_TYPE.BET_SLIP_BOTTOM)) {
      updateDiaAdvertisementImageLastShowedAt(DIA_ADVERTISEMENT_IMAGE_DISPLAYABLE_VIEW_TYPE.BET_SLIP_BOTTOM)
    }

    if (isShowBettingSlipKeepCartExplainImage()) {
      updateBettingSlipKeepCartExplainImageDisplayedUserList()
    }
  }

  const onClickMoneyButtonWrap = (value: number) => {
    let targetUserMoney
    if (betMoneyType === PROPERTY_ID.MONEY) {
      targetUserMoney = money
    } else if (betMoneyType === PROPERTY_ID.DIA) {
      targetUserMoney = diaMoney
    }

    const maxBetMoney = maxBetMoneyByBetMoneyType(betMoneyType, typeOn)
    onClickMoneyButton(value, targetCart, targetBetMoney, betMoneyType, targetUserMoney, maxBetMoney)
  }

  const onChangeTab = async (tab: Models.TabData) => {
    matchupStore.setSelectedBetSlipTabIndexKey(tab.key as BET_SLIP_TAB_INDEX_KEY)
    onClickMoneyReset()
    await matchupStore.refreshClubOption()
  }

  const onBetSlipChange = (event) => {
    matchupStore.setKeepCart(event.currentTarget.checked)
  }

  const isShowBettingSlipKeepCartExplainImage = () => {
    if (!isMobile) {
      return false
    }

    const enabled = globalStore.getBettingSlipKeepCartExplainImageDisplayEnabled()
    if (!enabled) {
      return false
    }

    const userList: string[] = StorageUtils.getBettingSlipKeepCartExplainImageDisplayedUserPromiseIds()
    const exist = find(userList, promiseId => promiseId === userInfo.id)
    return !exist
  }

  const updateBettingSlipKeepCartExplainImageDisplayedUserList = () => {
    const enabled = globalStore.getBettingSlipKeepCartExplainImageDisplayEnabled()
    if (!enabled) {
      return
    }

    const userList: string[] = StorageUtils.getBettingSlipKeepCartExplainImageDisplayedUserPromiseIds()
    userList.push(userInfo.id)
    StorageUtils.saveBettingSlipKeepCartExplainImageDisplayedUserPromiseIds(userList)
  }

  const tabs = [
    {
      title: <TabTxt className="white-tab-txt">G머니</TabTxt>,
      key: BET_SLIP_TAB_INDEX_KEY.MONEY,
    },
  ]
  if (globalStore.getUseDia()) {
    tabs.push({
      title: <TabTxt className="white-tab-txt dia-tab-txt">
        <DiaIco/><DiaTxtIco/>
      </TabTxt>,
      key: BET_SLIP_TAB_INDEX_KEY.DIA,
    })
  }

  // 베팅권 수량이 유효한 경우만 베팅권 탭을 표시한다.
  if (userInfo.ticket && getTicketCountFromTicket(BET_TICKET_TYPE.BET_TICKET1, userInfo.ticket) > 0) {
    tabs.push({
      title: <TabTxt className="white-tab-txt">베팅권</TabTxt>,
      key: BET_SLIP_TAB_INDEX_KEY.BET_TICKET,
    })
  }

  const onPriceValueChange = (values: NumberFormatValues) => {
    if (isInputNotAvailable(targetCart)) {
      return
    }

    const betMoneyType = getBetMoneyTypeFromSelectedBetSlipTab()

    if (betMoneyType !== PROPERTY_ID.MONEY && betMoneyType !== PROPERTY_ID.DIA) {
      return
    }

    let targetUserMoney
    if (betMoneyType === PROPERTY_ID.MONEY) {
      targetUserMoney = money
    } else if (betMoneyType === PROPERTY_ID.DIA) {
      targetUserMoney = diaMoney
    }

    const maxBetMoney = maxBetMoneyByBetMoneyType(betMoneyType, typeOn)

    const { value } = values
    const asNumber = Number(value)
    if (isExceedMaxBetMoney(asNumber, maxBetMoney)) {
      // 수동입력시에는 초과 입력시 최초 한번은 알림을 띄우지 않는 로직을 무시하고 무조껀 알림을 띄움.
      // MAX 버튼과 금액 버튼으로 입력시에도 이 함수는 동작하나, 이 함수 동작 이전에 이미 최대값 검증을 하고 최대값으로 설정했기 때문에
      // 여기 함수에서는 초과 입력에 대한 알림을 기존 그대로 유지 한다.
      const maxBetAlertText = makeMaxBetAlertText(betMoneyType, maxBetMoney)
      globalStore.showBubblePopupTimer(BubbleTextType.MAX_BET_ALERT, maxBetAlertText, BubbleType.BET_SLIP)
      const numberFormatValues = { value: maxBetMoney.toString() } as NumberFormatValues
      setUserInputBetMoney(numberFormatValues, targetUserMoney, updater, setUpdater)
      return
    }
    setUserInputBetMoney(values, targetUserMoney, updater, setUpdater)
  }

  const onClickDeleteCartItem = (e: string) => {
    const newCart = matchupStore.toggleCartItem(e)
    matchupStore.deleteCheckedCartItems()

    const nonCheckedCartList = filter(newCart, { checked: false })
    if (size(nonCheckedCartList) === 0) {
      matchupStore.toggleMinimizeBetSlip(true)
    }
  }
  const foldItems = makeFoldItems(targetCart, onClickDeleteCartItem)

  const renderContent = (tab) => {
    const tabKey = tab.key
    const betSlipId = `betSlip_${tabKey}`

    const funcSetBetMoney = matchupStore.setBetMoney
    const totalBetMoney = getRatioTicketMoney(targetBetMoney)

    const onClickTicketCountButtonHandler = (count: number, type: BET_TICKET_TYPE) => {
      if (isInputNotAvailable(targetCart)) {
        return
      }

      const betTicket = getTicketFromTicketCount(type, count)
      if (count !== Number.MAX_SAFE_INTEGER && (targetBetMoney + betTicket) > ticket) {
        showToast(TOAST_TYPE.INFO, '보유 베팅권이 부족합니다.')
        return
      }

      const maxBetMoney = maxBetMoneyByBetMoneyType(betMoneyType, typeOn)
      if (isExceedMaxBetMoney((targetBetMoney + betTicket) * 0.1, maxBetMoney)) {
        if ((targetBetMoney * 0.1) >= maxBetMoney) {
          const maxBetAlertText = makeMaxBetAlertText(betMoneyType, maxBetMoney)
          globalStore.showBubblePopupTimer(BubbleTextType.MAX_BET_ALERT, maxBetAlertText, BubbleType.BET_SLIP)
        }
        funcSetBetMoney(maxTicketBetMoney(), PROPERTY_ID.NEW_BET_TICKET_G)
        return
      }

      if (count + initialBetMoney < 0) {
        funcSetBetMoney(0, PROPERTY_ID.MONEY)
      } else {
        funcSetBetMoney(targetBetMoney + betTicket, PROPERTY_ID.NEW_BET_TICKET_G)
      }
    }

    const makeCouponButton = (value: number) => {
      const key = `coupon_bet_btn_${value}`
      return (
        <Button
          key={key}
          secondary
          className="bet-btn bet-coupon"
          onClick={() => onClickTicketCountButtonHandler(value, BET_TICKET_TYPE.BET_TICKET1)}
        >
          <img
            src={BetCouponImg}
            alt="베팅권"
          />
          <span>
            <span className="coupon-value"/>{value}
          </span>
        </Button>
      )
    }

    const makeMoneyButton = (value: number) => {
      const key = `money_bet_btn_${value}`
      return (
        <Button
          key={key}
          secondary
          className="bet-btn"
          onClick={() => onClickMoneyButtonWrap(value)}
        >
          {formatNumber(value)}<GmoneyIco/>
        </Button>
      )
    }

    const makeDiaButton = (value: number) => {
      const key = `money_bet_btn_${value}`
      return (
        <Button
          key={key}
          secondary
          className="bet-btn"
          onClick={() => onClickMoneyButtonWrap(value)}
        >
          {formatNumber(value)}<DiaIco/>
        </Button>
      )
    }

    const makeResetButton = (value) => {
      const key = `reset_bet_btn_${value}`
      return (
        <Button
          key={key}
          className="bet-btn other"
          onClick={() => onClickMoneyReset()}
        >
          {value}
        </Button>
      )
    }

    const makeMaxButton = (value) => {
      const key = `max_bet_btn_${value}`
      return (
        <Button
          key={key}
          className="bet-btn other"
          onClick={() => {
            let targetUserMoney
            if (betMoneyType === PROPERTY_ID.MONEY) {
              targetUserMoney = money
            } else if (betMoneyType === PROPERTY_ID.DIA) {
              targetUserMoney = diaMoney
            }
            const maxBetMoney = maxBetMoneyByBetMoneyType(betMoneyType, typeOn)
            onClickMoneyAllin(targetCart, targetUserMoney, maxBetMoney)
          }}
        >
          {value}
        </Button>)
    }

    const makeMaxCouponButton = (value) => {
      const key = `max_bet_btn_${value}`
      return (
        <Button
          key={key}
          className="bet-btn other"
          onClick={() => {
            const maxBetMoney = maxBetMoneyByBetMoneyType(betMoneyType, typeOn)
            onClickCouponAllin(targetCart, ticket, maxBetMoney)
          }}
        >
          {value}
        </Button>)
    }

    const makeGMoneyBetButton = () => {
      const makeButtons = []
      const targetBtns = isMobile ? gMoneyButtonMobile : gMoneyButtonPC
      for (let i = 0; i < targetBtns.length; i += 1) {
        if (targetBtns[i] === BET_SLIP_BTN_TYPE.MAX) {
          makeButtons.push(makeMaxButton(targetBtns[i]))
        } else if (targetBtns[i] === BET_SLIP_BTN_TYPE.RESET) {
          makeButtons.push(makeResetButton(targetBtns[i]))
        } else {
          makeButtons.push(makeMoneyButton(Number(targetBtns[i])))
        }
      }

      return makeButtons
    }

    const makeDiaBetButton = () => {
      const makeButtons = []
      const targetBtns = isMobile ? diaButtonMobile : diaButtonPC
      for (let i = 0; i < targetBtns.length; i += 1) {
        if (targetBtns[i] === BET_SLIP_BTN_TYPE.MAX) {
          makeButtons.push(makeMaxButton(targetBtns[i]))
        } else if (targetBtns[i] === BET_SLIP_BTN_TYPE.RESET) {
          makeButtons.push(makeResetButton(targetBtns[i]))
        } else {
          makeButtons.push(makeDiaButton(Number(targetBtns[i])))
        }
      }

      return makeButtons
    }

    const makeCouponBetButton = () => {
      const makeButtons = []
      const targetBtns = isMobile ? couponButtonMobile : couponButtonPC
      for (let i = 0; i < targetBtns.length; i += 1) {
        if (targetBtns[i] === BET_SLIP_BTN_TYPE.MAX) {
          makeButtons.push(makeMaxCouponButton(targetBtns[i]))
        } else if (targetBtns[i] === BET_SLIP_BTN_TYPE.RESET) {
          makeButtons.push(makeResetButton(targetBtns[i]))
        } else {
          makeButtons.push(makeCouponButton(Number(targetBtns[i])))
        }
      }

      return makeButtons
    }

    // 모바일과 PC 버튼 순서가 달라서 구분해두었습니다.
    const gMoneyButton = (
      <Fragment>
        <span className="bet-input">
          <NumberFormat
            className={betInputClassName}
            pattern="\d*"
            decimalScale={0}
            maxLength={20}
            allowNegative={false}
            value={uiInitialBetMoney || ''}
            thousandSeparator
            onValueChange={onPriceValueChange}
            disabled={isInputNotAvailable(targetCart) || (betMoneyType === PROPERTY_ID.MONEY && money <= 0)}
          />
          <GmoneyIco/>
        </span>
        {makeGMoneyBetButton()}
      </Fragment>
    )

    const diaButton = (
      <Fragment>
        <span className="bet-input">
          <NumberFormat
            className={betInputClassName}
            pattern="\d*"
            decimalScale={0}
            maxLength={20}
            allowNegative={false}
            value={uiInitialBetMoney || ''}
            thousandSeparator
            onValueChange={onPriceValueChange}
            disabled={isInputNotAvailable(targetCart) || (betMoneyType === PROPERTY_ID.DIA && dia <= 0)}
          />
          <DiaIco/>
        </span>
        {makeDiaBetButton()}
      </Fragment>
    )

    const betCoupon = (
      <Fragment>
        <span className="bet-input">
          {formatNumber(totalBetMoney)}
          <GmoneyIco/>
        </span>
        {makeCouponBetButton()}
      </Fragment>
    )

    const onClickBetSlipList = () => {
      if (!authStore.signedin) {
        authStore.showLoginPopup(<Login/>)
        return
      }

      if (isMobile) {
        globalStore.setVisibleBubbleBetList(true)
      } else {
        bettingHistoryStore.resetSelectedBettingHistory(FROM_VIEW_TYPE.BET_SLIP_BOTTOM)
        bettingHistoryStore.setBettingHistoryInitProps({
          onlyMajorClub: false,
          fromViewType: FROM_VIEW_TYPE.BET_SLIP_BOTTOM,
        })
        globalStore.addGeneralPopupProperties(<BettingHistory/>, '베팅 내역', {
          wrapClassName: '',
          className: '',
          isScroll: false,
          custom: false,
          clsBtn: false,
          closeCallback: () => {
            logStore.writeButtonLog({ pageId: 'c010', buttonId: '002' }).catch(console.error)
          },
        })
      }
    }


    const gMoneyInfo = (
      <Fragment>
        <span className="detail-txt">보유머니</span>
        <span className="detail-num">{formatNumber(money)}<GmoneyIco/></span>
      </Fragment>
    )
    const diaInfo = (
      <Fragment>
        <span className="detail-txt">보유다이아</span>
        <span className="detail-num">{formatNumber(diaMoney)}<DiaIco/></span>
      </Fragment>
    )
    const couponInfo = (
      <Fragment>
        <span className="detail-txt">보유베팅권</span>
        <span className="detail-num">{formatNumberTicketCount(BET_TICKET_TYPE.BET_TICKET1, ticket)}
          <span className="txt">개</span>
        </span>
      </Fragment>
    )

    let betSlipInfo
    let betSlipInputArea

    if (selectedBetSlipTabIndexKey === BET_SLIP_TAB_INDEX_KEY.MONEY) {
      betSlipInfo = gMoneyInfo
      betSlipInputArea = gMoneyButton
    } else if (selectedBetSlipTabIndexKey === BET_SLIP_TAB_INDEX_KEY.DIA) {
      betSlipInfo = diaInfo
      betSlipInputArea = diaButton
    } else {
      betSlipInfo = couponInfo
      betSlipInputArea = betCoupon
    }

    // 급액 버튼 영역
    // const betSlipInputArea = selectedBetSlipTabIndex === BET_SLIP_TAB_TYPE.MONEY ? gMoneyButton : betCoupon

    return (
      <Fragment>
        <ul id={betSlipId}
            className={(godBlessItemEnabled && isExtraOddsItemSupportBetMoneyType(betMoneyType)) ? 'bet-list short' : 'bet-list'}>
          {foldItems}
        </ul>
        <div className="bet-info">

          {godBlessItemEnabled
            && isExtraOddsItemSupportBetMoneyType(betMoneyType)
            && <AdditionalDividendCard/>}
          <ul className="bet-detail-info">
            <li>
              <span className="detail-txt">최대배당</span>
              <span className="detail-num max-value">
                {limitBettingRateText}<span className="txt">배</span>
              </span>
            </li>
            <li>
              <span className="detail-txt">총배당</span>
              {/* 싱글 페널티 */}
              {/* 백스크롤 발생시 popover의 위치가 변경되는 현상이 발생하여 position: 'fixed' 추가 */}
              {isSingleBetPenalty ?
                <Popover placement="topRight" content={betSlipPenaltyTxt} trigger="click"
                         overlayStyle={{ position: 'fixed' }}>
                  <Button className="penalty-info-btn">
                    <span className="detail-num point total">
                      <PopoverIco/>
                      {rate.toFixed(2)}
                    </span>

                  </Button>
                </Popover> :
                <span className="detail-num point total">{rate.toFixed(2)}</span>
              }

            </li>
            <li>
              {betSlipInfo}
            </li>
            <li>
              {selectedBetSlipTabIndexKey === BET_SLIP_TAB_INDEX_KEY.DIA ?
                <Fragment>
                  <span className="detail-txt">예상적중다이아</span>
                  <span className="detail-num point">{formatNumber(exchangedHitMoney)}<DiaIco/></span>
                </Fragment>
                :
                <Fragment>
                  <span className="detail-txt">예상적중머니</span>
                  <span className="detail-num point">{formatNumber(exchangedHitMoney)}<GmoneyIco/></span>
                </Fragment>
              }
            </li>
          </ul>

          {/* TODO 탭이 변경될 시 입력된 재화 값은 초기화되어야 합니다. */}
          {betSlipInputArea}

          <Button
            className="ongoing-bet-btn"
            onClick={onClickBetSlipList}
          >
            {isMobile ? '진행중 베팅' : '진행중'}
            <Badge
              text={onGoingBetCount}
              overflowCount={99}
              css={BadgeStyle}
            />
            {/*<span className="plus-ani">+1</span>*/}
            {visibleBetCompleteAni && <span className="plus-ani">+1</span>}
          </Button>

          {!useBetSlipRefreshButtonInsteadOfBettingButton && (<Button onClick={(e) => {
            e.currentTarget.blur()
            doBet(targetCart, categoryTab, sportTab, '#bet_slip_bottom_money_input input', rate)
          }} className={betButtonClassName} secondary>
            {/* ***** 베팅 완료되기까지의 로딩 ***** */}
            {isBetting ? <BottomLoading/> : '베팅하기'}
          </Button>)}

          {useBetSlipRefreshButtonInsteadOfBettingButton && (<Button onClick={() => {
            globalStore.resetGeneralPopupProperties()
            matchupStore.clearCart()
            routerStore.push('/')
          }} className={`${betButtonClassName} refresh-btn`}>
            새로고침
          </Button>)}
        </div>
      </Fragment>
    )
  }

  let keepTxt
  if (isMobile) {
    keepTxt = '베팅 후 슬립유지'
  } else {
    keepTxt = '슬립 유지'
  }

  let wrappingClass
  if (isMobile && foldCount !== 0) {
    wrappingClass = `wrapping ${foldClass} ${rateClass}`
  } else {
    wrappingClass = 'wrapping'
  }

  const onClickBetSlipGuideClose = () => {
    setBetSlipGuideClass('adv-hidden')
  }

  const visibleDiaAdvertisementImage = isShowDiaAdvertisementImage(
    DIA_ADVERTISEMENT_IMAGE_DISPLAYABLE_VIEW_TYPE.BET_SLIP_BOTTOM,
  )
  const visibleBettingSlipKeepCartExplainImage = isShowBettingSlipKeepCartExplainImage()

  // 베팅슬립 분석글 혜택 팝업
  const banner = (
    <img src={UserPickBannerImg} alt="분석글 작성하고 혜택 받자!"/>
  )

  const onClickDetailBenefit = () => {
    logStore.writeButtonLog({ pageId: 'b070', buttonId: '002' }).catch(console.error)
    PopupUtils.showUserPickGiveawayInfo()
  }

  const betSlipListWrapClass = classNames('', {
    'android-betslip': isAndroid,
    'ios-betslip': isIOS,
  })

  return (
    <Fragment>
      <BetSlipBottomModal className="betslip-bottom">
        <Wrapping className={wrappingClass}
                  style={{ animationDuration: `${betSlipAniSec}s` }}
        >
          {/* 베팅 슬립 최소화 */}
          {isMobile &&
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
            <div id="simpleBetslip" className={simple.join(' ')} onClick={onClickBetSlipExpandButton}>

            <span
              className={foldCount === 0 ? 'fold-num zero' : 'fold-num'}
            >{foldCount}</span>
              {foldCount !== 0 &&
                <Fragment>
                  <span className="line"/>
                  <span className="rate">{rate === 0 ? 0 : rate.toFixed(2)}</span>
                </Fragment>
              }

              {/*<div className="betslip-simple-fold" css={css`*/}
              {/*    .betslip-ani::before {*/}
              {/*      animation-duration: ${betSlipAniSec}s;*/}
              {/*    }*/}
              {/*    `}>*/}
              {/*  <span className={`betslip-simple-num betslip-ani fold ${foldClass} ${rateClass}`} style={{ animationDuration: `${betSlipAniSec}s` }}>*/}
              {/*    /!*<span className="betslip-ani--bg big" style={{ animationDuration: `${betSlipAniSec}s` }}/>*!/*/}
              {/*    <span className="ani-num" style={{ animationDuration: `${betSlipAniSec}s` }}>{foldNum}</span>*/}
              {/*  </span>*/}
              {/*</div>*/}

              {/*<div className="betslip-simple-rate">*/}
              {/*  /!* 싱글 페널티 *!/*/}
              {/*  /!* 베팅슬립은 상시 하단에 붙어있으므로 overlayStyle={{ position: 'fixed' }}를 해줘야 스크롤해도 popover가 하단에 위치함 *!/*/}
              {/*  {isSingleBetPenalty ?*/}
              {/*    <Popover placement="topRight" content={betSlipPenaltyTxt} trigger={isMobile ? 'click' : 'hover'} overlayStyle={{ position: 'fixed' }}>*/}
              {/*      <Button className="tooltip-btn bet-slip min" onClick={(e) => e.stopPropagation()}>*/}
              {/*        <span className="betslip-top-wrap--info--txt">배당</span>*/}
              {/*        <PopoverIco/>*/}
              {/*      </Button>*/}
              {/*    </Popover> :*/}
              {/*    <span className="betslip-top-wrap--info--txt original-code">배당</span>*/}
              {/*  }*/}
              {/*  <span className="betslip-simple-num rate">*/}
              {/*    <span*/}
              {/*      className="ani-num"*/}
              {/*      style={{ animationDuration: `${betSlipAniSec}s` }}>{rate === 0 ? 0 : rate.toFixed(2)}</span>*/}
              {/*  </span>*/}
              {/*</div>*/}
            </div>
          }

          {/* 베팅 슬립 펼침 */}
          <div className={detail.join(' ')}>
            {isMobile && <ModalBg onClick={onClickBetSlipCollapseButton}/>}
            {isMobile && onGoingBetCount > 0 &&
              <AdvButton
                contents={banner}
                css={UserPickBannerStyle}
                onClick={onClickDetailBenefit}
                className="bet-slip"
              />
            }
            <WhiteChildTabWrap className="betslip-tab">
              {isMobile && !isEmpty(club?.listTextImageUrl) && Utils.isMembershipClub(club?.grade) &&
                <div className="club-list-wrap">
                  <img src={club.listTextImageUrl} onError={null} alt="클럽 아이콘" loading="lazy" className="icon"/>
                </div>
              }
              <Button className="toggle-betslip-btn" onClick={onClickBetSlipCollapseButton}>
                <span className="cls-ico"/>
              </Button>
              <BetSlipListWrap className={betSlipListWrapClass}>
                <div className="bet-header">
                  <span className="fold">
                  <span className="fold-num">{size(foldItems)}</span>
                  폴드
                  </span>
                  <span className="keep-bet">
                    {keepTxt}
                    <SwitchBtn
                      type="checkbox"
                      id="keepBetSetting"
                      name="keepBetSetting"
                      className="keep-bet--btn"
                      value="keepBet"
                      checked={isKeepCart}
                      onChange={onBetSlipChange}
                      width={58}
                      height={22}
                      marginLeft={7}
                    />
                    <label htmlFor="keepBetSetting" className="on-off-wrap">
                      <span className="on">ON</span>
                      <span className="off">OFF</span>
                    </label>
                  </span>
                  <Button className="delete-all" onClick={clearAllCart}>
                    <span className="x-ico"/>
                    전체삭제
                  </Button>

                  {isMobile && (visibleDiaAdvertisementImage || visibleBettingSlipKeepCartExplainImage) &&
                    <BetSlipGuideTxtWrap className={betSlipGuideClass} onClick={onClickBetSlipGuideClose}>
                      <ModalBg className="modal-bg"/>
                      {visibleDiaAdvertisementImage &&
                        <img src={BetslipDiaGuideImg} alt="다이아도 베팅할 수 있습니다." className="dia-txt-guide"/>
                      }
                      {visibleBettingSlipKeepCartExplainImage &&
                        <img src={BetslipSlipGuideImg} alt="슬립유지 시 베팅 후에도 선택경기가 카트에 남아있습니다."
                             className="slip-txt-guide"/>
                      }
                    </BetSlipGuideTxtWrap>
                  }
                </div>

                <Tabs
                  tabs={tabs}
                  initialPage={0}
                  page={selectedBetSlipTabIndexKey}
                  onChange={onChangeTab}
                  animated={false}
                  swipeable={false}
                  renderTabBar={tabProps => {
                    return <Tabs.DefaultTabBar {...tabProps} page={tabs.length}/>
                  }}
                >
                  {renderContent}
                </Tabs>
              </BetSlipListWrap>

            </WhiteChildTabWrap>
            <BubblePopup type={BubbleType.BET_SLIP}/>
          </div>
        </Wrapping>
      </BetSlipBottomModal>
      {/*<BettingCouponPopup/>*/}
      {!isMobile && onGoingBetCount > 0 &&
        <div>
          <AdvButton
            contents={banner}
            css={UserPickBannerStyle}
            onClick={onClickDetailBenefit}
            className="bet-slip pc"
          />
        </div>
      }
    </Fragment>
  )
}

export default observer(BetSlipBottom)
